/**
 * V2QsStageMileMarker 컴포넌트 Props 인터페이스
 * V1 QsStageMileMarker의 V2 버전 (순수 UI만)
 *
 * 설문 진행 단계 마커 컴포넌트
 */

/**
 * 단계 상태
 */
export type V2QsStageStatus = 'completed' | 'current' | 'pending';

/**
 * 단계 정보
 */
export interface V2QsStage {
  /**
   * 단계 키 (고유 식별자)
   */
  key: string;

  /**
   * 단계 이름
   */
  name: string;

  /**
   * 단계 설명 (현재 단계에서만 표시)
   */
  description?: string;

  /**
   * 단계 상태
   */
  status: V2QsStageStatus;
}

export interface V2QsStageMileMarkerProps {
  /**
   * 제목
   */
  title?: string;

  /**
   * 단계 목록
   */
  stages: V2QsStage[];

  /**
   * 현재 단계 클릭 시 콜백 (다음으로 진행)
   */
  onCurrentStageClick?: () => void;

  /**
   * 히어로 이미지 URL
   */
  heroImageUrl?: string;

  // i18n 텍스트 Props
  /**
   * 완료된 단계 라벨 (접근성)
   */
  completedLabel?: string;

  /**
   * 추가 CSS 클래스
   */
  className?: string;
}

export const defaultV2QsStageMileMarkerProps: Partial<V2QsStageMileMarkerProps> = {
  completedLabel: 'Completed',
};
